import React from 'react';
import PropTypes from 'prop-types';
import Tooltip from '../../common/Tooltip/Tooltip';
import globals from '../../../globals/communityGlobals';
import { cardTypes, OVERRIDE_CLINICIANS_COUNT } from '../../../settings/constants';

const locale = globals.getArea('dailyPlanning');

function RenderBlank() {
  return <span className="blank_icon" />;
}

function RenderMaster(copiesCount, handleAdd) {
  if (copiesCount >= OVERRIDE_CLINICIANS_COUNT) {
    return (
      <Tooltip content={locale.getMsg('tooManyOverrides')}>
        <span className="treatment-actions-icons">
          <i role="button" tabIndex="-1" className="allocateIcons icon or-disabled" disabled>
            add_circle
          </i>
        </span>
      </Tooltip>
    );
  }

  return (
    <span className="treatment-actions-icons">
      <i role="button" tabIndex="-1" className="allocateIcons icon or-add" onClick={handleAdd}>
        add_circle
      </i>
    </span>
  );
}

function RenderAdditional() {
  return RenderBlank();
}

function RenderOverride(handleRemove) {
  return (
    <span className="treatment-actions-icons">
      <i role="button" tabIndex="-1" className="allocateIcons icon or-remove" onClick={handleRemove}>
        delete
      </i>
    </span>
  );
}

function OverrideClinician({ cardType, copiesCount, occurrence, handleAdd, handleRemove }) {
  if (globals.now.isAfter(occurrence, 'day')) {
    return RenderBlank();
  }

  switch (cardType) {
    case cardTypes.MASTER:
    case cardTypes.REVIEW:
      return RenderMaster(copiesCount, handleAdd);
    case cardTypes.ADDITIONAL_CLINICIAN:
      return RenderAdditional();
    case cardTypes.OVERRIDDEN_CLINICIAN:
      return RenderOverride(handleRemove);
    default:
      throw new Error('Unknown card type');
  }
}

OverrideClinician.propTypes = {
  cardType: PropTypes.string.isRequired,
  copiesCount: PropTypes.number.isRequired,
  occurrence: PropTypes.string.isRequired,
  handleAdd: PropTypes.func.isRequired,
  handleRemove: PropTypes.func.isRequired,
};

export default OverrideClinician;
